import { useCallback } from 'react';
import { standardRequestWithFlash } from 'shared/utils/request';
import { Person } from 'talent_matching/types';
import useQueryHelper from 'talent_matching/hooks/use_query_helper';
import { useAdvancedCandidateCount } from 'talent_matching/contexts/advanced_candidate_count_context';
import { useTalentMatchingTabContext } from 'talent_matching/contexts/talent_matching_tab_context';

const useAdvanceCandidate = (actionSource: string) => {
  const { excludePeople } = useQueryHelper();
  const { onAdvanceSuccess } = useAdvancedCandidateCount();
  const { appReviewSessionId } = useTalentMatchingTabContext();

  return useCallback(
    async (candidate: Person, onSuccess?: () => void) => {
      if (!candidate.advancePath) {
        return;
      }

      try {
        await standardRequestWithFlash.post(candidate.advancePath, {
          app_review_session_id: appReviewSessionId,
          source: 'talent_matching',
          action_source: actionSource,
        });
        excludePeople([candidate.id]);
        onAdvanceSuccess(candidate);
        onSuccess?.();
      } catch {
        return;
      }
    },
    [appReviewSessionId, actionSource, excludePeople, onAdvanceSuccess]
  );
};

export default useAdvanceCandidate;
